import React from "react";
import ReactDOM from "react-dom";
import Home from "./pages/Home";
//import "font-awesome/css/font-awesome.min.css";
//ReactDOM.render(<Home />, document.getElementById("root"));
ReactDOM.render(React.createElement(Home, null), document.getElementById("campaignData"));
